// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    import { TravelRates } from '../Classes/TravelRates';
import { IndividualTravelExpenses } from '../Classes/IndividualTravelExpenses';
export class TravelExpenses {
  travelRates: TravelRates;
  pmExpenses: IndividualTravelExpenses;
  elecExpenses: IndividualTravelExpenses;
  engExpenses: IndividualTravelExpenses;
  mechExpenses: IndividualTravelExpenses;
  specExpenses: IndividualTravelExpenses;
  totalTravelCost: number;
  salesOffice: number;
  nengExpenses: IndividualTravelExpenses;
  qengExpenses: IndividualTravelExpenses;
  cengExpenses: IndividualTravelExpenses;
  eengExpenses: IndividualTravelExpenses;
  lengExpenses: IndividualTravelExpenses;
}
